var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import { connect } from 'react-redux';
import globalConstants from 'app/constants/global-constants';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { getAllowedUseCases } from 'app/helpers/globalHelpers';
import { beginCreateSandbox } from '../../actions/sandboxActions';
import SandboxCreate from './SandboxCreate';
import Button from '../../components/Button/Button';
var SandboxCreateIndex = /** @class */ (function (_super) {
    __extends(SandboxCreateIndex, _super);
    function SandboxCreateIndex(props) {
        var _this = _super.call(this, props) || this;
        var useCases = getAllowedUseCases(props.remoteUseCases).filter(function (i) { return props.runningSandboxNames.indexOf(i.name) === -1; });
        var querySearchObject = queryString.parse(window.location.search);
        _this.state = {
            useCases: useCases,
            activeDataset: useCases[0],
            personaFilter: ['developer', 'data-scientist'].indexOf(querySearchObject.persona) > -1 ? querySearchObject.persona : null,
        };
        _this.handleSandboxSelectItem = _this.handleSandboxSelectItem.bind(_this);
        _this.handleSandboxCreate = _this.handleSandboxCreate.bind(_this);
        _this.handlePersonaFilterChange = _this.handlePersonaFilterChange.bind(_this);
        return _this;
    }
    SandboxCreateIndex.prototype.handlePersonaFilterChange = function (value) {
        this.setState({
            personaFilter: value,
        });
    };
    SandboxCreateIndex.prototype.handleSandboxSelectItem = function (value) {
        this.setState({ activeDataset: value });
    };
    SandboxCreateIndex.prototype.handleSandboxCreate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var activeDataset, _a, handleBeginCreateSandbox, history, toLaunchUseCaseName, isDraft;
            return __generator(this, function (_b) {
                activeDataset = this.state.activeDataset;
                _a = this.props, handleBeginCreateSandbox = _a.handleBeginCreateSandbox, history = _a.history;
                toLaunchUseCaseName = activeDataset.name;
                isDraft = false;
                handleBeginCreateSandbox({ usecase: toLaunchUseCaseName, isDraft: isDraft });
                return [2 /*return*/];
            });
        });
    };
    SandboxCreateIndex.prototype.render = function () {
        var _a = this.props, isCreating = _a.isCreating, onClose = _a.onClose;
        var _b = this.state, useCases = _b.useCases, activeDataset = _b.activeDataset, personaFilter = _b.personaFilter;
        return (React.createElement(SandboxCreate, { onSandboxItemSelect: this.handleSandboxSelectItem, activeDataset: activeDataset, useCases: useCases, onClose: onClose, actionComponent: (React.createElement(Button, { onClick: this.handleSandboxCreate, color: "blue", loading: isCreating, labeled: true, className: "flex items-center" }, globalConstants.dictionary.launchAndDownloadProject)), personaFilter: personaFilter, handlePersonaFilterChange: this.handlePersonaFilterChange }));
    };
    return SandboxCreateIndex;
}(Component));
var mapStateToProps = function (state) { return ({
    runningSandboxNames: state.sandbox.items && state.sandbox.items.map(function (i) { return i.usecase; }),
    user: state.user,
    isCreating: state.sandbox.isCreating,
    remoteUseCases: state.sandbox.useCases,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    handleBeginCreateSandbox: function (params) { return dispatch(beginCreateSandbox(params)); },
}); };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SandboxCreateIndex));
